import React, {Component} from 'react';
import {connect} from 'react-redux';
import StepControlButton, {CONTROL_NEXT, CONTROL_PREV} from "../../components/navigation/StepControlButton";
import {isProductSelectionStepValid} from "../../selectors/StepValidation";
import {getAppMode} from "../../selectors/Mode";
import {forceValidationOnSteps} from "../../actions/StepControl";
import {ToggleSelection, ToggleSelectionButtons} from "../util/ToggleSelection";
import ToggleButton, {THEME_BLOCK_DESCRIPTION, THEME_SEPARATOR} from "../../components/ToggleButton";
import {faLayerGroup} from "@fortawesome/pro-light-svg-icons/faLayerGroup";
import {PRODUCT_SELECTION_AGENCY, PRODUCT_SELECTION_AVMANAGER, PRODUCT_SELECTION_AVMANAGER_LITE, PRODUCT_SELECTION_AVMANAGER_UNLIMITED, PRODUCT_SELECTION_CONSUMER, PRODUCT_SELECTION_PROSPACE, PRODUCT_SELECTION_SPACESERVER} from "../../constants/General";
import * as StepLabels from "../../constants/StepLabels";
import StepValidationErrors from "../../components/StepValidationErrors";
import {activateBaseArticle, selectBaseArticle} from "../../actions/BaseArticle";
import {agencyServerArticleNumber} from "../../config/Config";
import {queryCartRemoveAllItems, queueItemOperation} from "../../actions/Cart";
import {queryAddInitialProject, setInitialConfigurationByState} from "../../actions/ProjectSelection";
import {faGavel} from "@fortawesome/pro-light-svg-icons/faGavel";
import {faPlanetRinged} from "@fortawesome/pro-light-svg-icons/faPlanetRinged";
import {toggleSelectionTriggered} from "../../actions/Util";
import {faMicrochip} from "@fortawesome/pro-light-svg-icons/faMicrochip";

function mapStateToProps(state) {
    return {
        productSelectionStepValid: isProductSelectionStepValid(state),
        mode: getAppMode()
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        forceValidation: () => {
            dispatch(forceValidationOnSteps([ownProps.stepLabel]))
        },
        initializeConfiguratorByState: (target) => {
            dispatch(setInitialConfigurationByState(target));
        },
        clearCart: () => {
            return dispatch(queueItemOperation(queryCartRemoveAllItems));
        },
        clearSelection: () => {
            dispatch(toggleSelectionTriggered('productSelection', null))
        },
        activateBaseArticle: (articleNumber, addToCart) => {
            return dispatch(activateBaseArticle(articleNumber, addToCart));
        },
        addInitialProject: () => {
            return dispatch(queryAddInitialProject());
        }
    };
}

class ProductSelectionStep extends Component {

    constructor(props) {
        super(props);

        this.state = {
            canToggle: true
        }
    }

    handleButtonNextClick = (e) => {
        if (this.props.productSelectionStepValid === true) {
            this.props.onButtonNextClick()
        } else {
            this.props.forceValidation()
        }
    }

    render() {


        return (
            <div className="step-display__page tarifselection-step">

                <StepValidationErrors
                    validationResult={this.props.productSelectionStepValid}
                    stepLabel={StepLabels.PRODUCT_SELECTION}
                />

                <h1>Weiteren Tarif im mittwald Kundencenter hinzufügen</h1>

                <ToggleSelection
                    id="productSelection"
                    onSelect={(target) => {
                        this.setState({canToggle: false});
                        if (target === PRODUCT_SELECTION_AGENCY) {
                            this.props.clearCart().then(() => {
                                this.props.activateBaseArticle(agencyServerArticleNumber, true)
                                this.props.initializeConfiguratorByState(target);
                                this.props.addInitialProject().then(args => {
                                    this.setState({canToggle: true});
                                })
                            })
                        } else if (target === PRODUCT_SELECTION_CONSUMER) {
                            this.props.clearCart().then(() => {
                                this.setState({canToggle: false});
                                this.props.activateBaseArticle("70500")
                                this.props.initializeConfiguratorByState(target);
                                this.props.addInitialProject().then(args => {
                                    this.setState({canToggle: true});
                                });
                            })
                        } else if (target === PRODUCT_SELECTION_AVMANAGER_LITE) {
                            this.props.clearCart().then(() => {
                                this.setState({canToggle: false});
                                this.props.activateBaseArticle("191025", true)
                                this.setState({canToggle: true});
                            })
                        } else if (target === PRODUCT_SELECTION_AVMANAGER_UNLIMITED) {
                            this.props.clearCart().then(() => {
                                this.setState({canToggle: false});
                                this.props.activateBaseArticle("191026", true)
                                this.setState({canToggle: true});
                            })
                        } else if (target === PRODUCT_SELECTION_PROSPACE) {
                            this.props.clearCart().then(() => {
                                this.setState({canToggle: true});
                                window.open('https://www.mittwald.de/webhosting?etcc_cu=onsite&etcc_cmp_onsite=internalads&etcc_med_onsite=kc_bestellstrecke_webhosting#config', '_blank');
                                setTimeout(() => {
                                    this.props.clearSelection();
                                }, 250);
                            })
                        } else if (target === PRODUCT_SELECTION_SPACESERVER) {
                            this.props.clearCart().then(() => {
                                this.setState({canToggle: true});
                                window.open('https://www.mittwald.de/vserver?etcc_cu=onsite&etcc_cmp_onsite=internalads&etcc_med_onsite=kc_bestellstrecke_vserver#config', '_blank');
                                setTimeout(() => {
                                    this.props.clearSelection();
                                }, 250);
                            })
                        }
                    }}
                >
                    <ToggleSelectionButtons>
                        <ToggleButton
                            disabled={!this.state.canToggle}
                            icon={faLayerGroup}
                            target={PRODUCT_SELECTION_CONSUMER}
                            buttonLabel="CMS- oder Shop-Hosting"
                            theme={THEME_BLOCK_DESCRIPTION}
                            description="Dein Hosting für ein einzelnes CMS- oder Shop-Projekt. Du bestimmst die Größe anhand der erwarteten Besucherzahl. Wir kümmern uns um die Technik. Dein Projekt verwaltest du im Kundencenter."
                            hint={"ab 15.00 € mtl.*"}
                        />
                        <ToggleButton
                            disabled={!this.state.canToggle}
                            icon={faLayerGroup}
                            target={PRODUCT_SELECTION_AGENCY}
                            buttonLabel="Agentur-Server"
                            theme={THEME_BLOCK_DESCRIPTION}
                            description="Das digitale Zuhause für viele Projekte. Du nennst uns die Besucherzahl, wir konfigurieren die Technik. Über das Kundencenter verwaltest du alles mit nur einem Login und entwickelst kostenlos bis zum Go-Live."
                            hint={"ab 4.00 € mtl.*"}
                        />

                        <h2>
                            Kennst du schon?
                        </h2>
                        <ToggleButton
                            disabled={!this.state.canToggle}
                            icon={faGavel}
                            target={PRODUCT_SELECTION_AVMANAGER_LITE}
                            buttonLabel="AV-Manager lite"
                            theme={THEME_BLOCK_DESCRIPTION}
                            description="Bis zu 10 rechtssichere Auftragsverarbeitungsverträge und Verarbeitungsverzeichnis erstellen und verwalten. DSGVO-konform. 200 Vorlagen speziell für Agenturen & Freelancer."
                            hint={"9.00 € mtl.*"}
                        />
                        <ToggleButton
                            disabled={!this.state.canToggle}
                            icon={faGavel}
                            target={PRODUCT_SELECTION_AVMANAGER_UNLIMITED}
                            buttonLabel="AV-Manager unlimited"
                            theme={THEME_BLOCK_DESCRIPTION}
                            description="Einfach rechtssichere Auftragsverarbeitungsverträge und Verarbeitungsverzeichnis erstellen und verwalten. DSGVO-konform. 200 Vorlagen speziell für Agenturen & Freelancer."
                            hint={"24.00 € mtl.*"}
                        />

                        <h2>
                            Managed Cloud Hosting
                        </h2>
                        <h3>Neue Tarife, neue Verwaltung - jetzt ausprobieren:</h3>
                        <ToggleButton
                            disabled={!this.state.canToggle}
                            icon={faPlanetRinged}
                            target={PRODUCT_SELECTION_PROSPACE}
                            buttonLabel="Webhosting"
                            style="prospace"
                            theme={THEME_BLOCK_DESCRIPTION}
                            description="Vom One-Pager bis zur Unternehmensseite - für jedes Projekt findest du das passende Setup. Und für deine individuelle Lösung kannst du deinen Tarif so konfigurieren, wie du es brauchst."
                            hint={"ab 13.00 € mtl.*"}
                            isExternalLink={true}
                        />
                        <ToggleButton
                            disabled={!this.state.canToggle}
                            icon={faMicrochip}
                            target={PRODUCT_SELECTION_SPACESERVER}
                            buttonLabel="vServer"
                            style="spaceserver"
                            theme={THEME_BLOCK_DESCRIPTION}
                            description="Webshop oder Unternehmensseite - pack drauf, was du willst und so viel du willst. Deine individuelle Konfiguration kannst du genau an deine Anforderungen anpassen."
                            hint={"ab 21.00 € mtl.*"}
                            isExternalLink={true}
                        />
                    </ToggleSelectionButtons>

                </ToggleSelection>

                <div className="step-display__page__control">
                    {this.props.prevLabel !== "" ? <StepControlButton
                        type={CONTROL_PREV}
                        label={this.props.prevLabel}
                        onClick={this.props.onButtonPrevClick}
                    /> : null}
                    {this.props.nextLabel !== "" ? <StepControlButton
                        disabled={this.props.productSelectionStepValid !== true}
                        type={CONTROL_NEXT}
                        label={this.props.nextLabel}
                        onClick={this.handleButtonNextClick}
                    /> : null}
                </div>

            </div>
        );
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ProductSelectionStep);



/** WEBPACK FOOTER **
 ** ./src/containers/productselection/ProductSelectionStep.js
 **/